<ng-content></ng-content><i *ngIf="value && value!=''" class="fa fa-clone" aria-hidden="true" (click)="copy()"
    ng-prevent-drag="true"></i>